export const readerService = () => {
  function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result, img))
    reader.readAsDataURL(img)
  }

  return {
    getBase64
  }
}
